var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDiamondGreen = function SvgDiamondGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 248 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20h248",
    stroke: "#00412F",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.75 0c0 10.925-8.864 19.75-19.75 19.75v.5c10.925 0 19.75 8.864 19.75 19.75h.5c0-10.925 8.864-19.75 19.75-19.75v-.5c-10.925 0-19.75-8.864-19.75-19.75h-.5Z",
    fill: "#00412F"
  })));
};

export { SvgDiamondGreen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQ4IiBoZWlnaHQ9IjQwIiB2aWV3Qm94PSIwIDAgMjQ4IDQwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMCAyMEwyNDggMjAiIHN0cm9rZT0iIzAwNDEyRiIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMjMuNzUgMEMxMjMuNzUgMTAuOTI0NiAxMTQuODg2IDE5Ljc1IDEwNCAxOS43NVYyMC4yNUMxMTQuOTI1IDIwLjI1IDEyMy43NSAyOS4xMTQxIDEyMy43NSA0MEgxMjQuMjVDMTI0LjI1IDI5LjA3NTQgMTMzLjExNCAyMC4yNSAxNDQgMjAuMjVWMTkuNzVDMTMzLjA3NSAxOS43NSAxMjQuMjUgMTAuODg1OSAxMjQuMjUgMEgxMjMuNzVaIiBmaWxsPSIjMDA0MTJGIi8+Cjwvc3ZnPgo=";